import { onMounted, watch, computed } from "vue"
import { useStore } from "vuex"
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'

export default {
    name: "TilmeldHoldKvittering",
    props: {
        hasProfile: {
            type: Boolean,
            required: false
        }
    },
    setup(){
        const store = useStore()
        const gtmActive = !!window?.dataLayer?.find(
            (element) => element['gtm.start']
        ) // check if gtm is active

        const loginUrl = store.state.main.page_overlay_content_data.loginUrl
        const createProfileUrl = store.state.main.page_overlay_content_data.createProfileUrl
        const hasProfile = store.state.main.page_overlay_content_data.hasProfile

        let first,
            last,
            close

        const tabTrap = function (e) {
            if (e.shiftKey && e.target.dataset.order === 'first') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && e.target.dataset.order === 'last') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && !e.target.dataset.order) {
                e.preventDefault()
                first.focus()
            }
        }

        onMounted(() => {
            
            first = document.querySelector(
                '.kb-button[data-order="first"]'
            )
            last = document.querySelector(
                '.kb-button[data-order="last"]'
            )
            close = document.querySelector('.kb-page-overlay__close')
            onTransitionendCallback(
                {
                    opening() {
                        first.focus()
                    }
                },
                { persistent: true }
            )

            const orderId = new URLSearchParams(document.location.search).get(
                'orderId'
            )
            if (orderId)
                store.dispatch('main/trackPurchaseData', { orderId })
        })
        
        return {
            loginUrl,
            createProfileUrl,
            hasProfile,
            tabTrap,
            getLabel: (labelKey) =>
                store.getters['labels/getLabel']({
                    labelCollection: 'TilmeldHoldKvittering',
                    labelKey
                })
        }
    }
}